export default "__VITE_ASSET__HSUJD5oB__"